export default __webpack_public_path__ + "static/media/646.eb3fd0ca.jpg";